import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-[#F8F3EC]" data-id="element-354" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-355" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-356" data-mp="cm4yoh5rxzgs">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-[#520128]" data-id="element-357" data-mp="7qhe6f28luhm">
            THE COMPLETE <span className="text-[#8E2C5C]" data-id="element-358" data-mp="3g6116wcbego8">6-IN-1</span> SEWING &amp; PATTERN MAKING INSTRUCTOR{' '}
            <span className="bg-[#520128] text-white px-2 box-decoration-clone" data-id="element-359" data-mp="3c4xkk7mg0gly">ATLAS</span> SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-360" data-mp="3px41hvxf6rmg">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-[#C9A24A] shadow-lg shadow-[#520128]/10' : 'border-[#E6D5BF] shadow-sm shadow-[#520128]/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-361" data-mp="3l27xdxewsdsz" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-[#8E2C5C] text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-362" data-mp="1qh606sjai42b">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-363" data-mp="20divfuuhgpz6">
                <span className="w-12 h-12 rounded-xl bg-[#520128] text-white font-extrabold text-2xl flex items-center justify-center shrink-0 border-b-4 border-[#C9A24A]" aria-hidden="true" data-id="element-364" data-mp="24hgsm008zqpl">
                  0{index + 1}
                </span>
                <div data-id="element-365" data-mp="1gprn2ubtrjis">
                  <div className="text-[#8A6A2B] font-bold text-sm uppercase tracking-wider" data-id="element-366" data-mp="1gp9jfcmu230u">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-[#520128]" data-id="element-367" data-mp="1ps0u3a7vwurf">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-[#8A6A2B] font-semibold mb-6 border-l-4 border-[#C9A24A] pl-4" data-id="element-368" data-mp="x2btgxz36wqc">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-369" data-mp="16u7r67x9gku1">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-370" data-mp="120lo97gwfvbf">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-371" data-mp="9b6cuglbo0ez">
                      {volume.questions.map(question => <li key={question} className="text-[#520128] font-semibold text-sm bg-[#F8F3EC] border border-[#E6D5BF] rounded-lg px-3 py-2" data-id="element-372" data-mp="2pr2rnrv6sv79">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-[#520128] font-bold text-base bg-[#F1E6D8] border-l-4 border-[#C9A24A] rounded-lg px-4 py-3" data-id="element-373" data-mp="38qp20bo8ztdp">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-700 text-sm leading-relaxed" data-id="element-374" data-mp="2zrle8ue4ypsv">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-375" data-mp="1obd8kk3eqycz">
                <div data-id="element-376" data-mp="1obwqw1wyzorj">
                  <p className="text-[#520128] font-semibold text-sm mb-3" data-id="element-377" data-mp="1o7z85heb0z86">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-378" data-mp="23ltizsuq58r5">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-379" data-mp="2mjcur48kh5h9">
                        <CheckCircle2 size={18} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-380" data-mp="2mgi6t2qch2j3" />
                        <span className="text-slate-700 text-sm" data-id="element-381" data-mp="2ifeugq7i9omm">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-382" data-mp="122q1tp1bdov8">
                    <p className="text-[#520128] font-semibold text-sm mb-3" data-id="element-383" data-mp="12413njb78mjp">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-384" data-mp="x69c4qegv2g1">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-385" data-mp="rzuhoolvxwqv">
                          <CheckCircle2 size={18} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-386" data-mp="wxvwgxca39wj" />
                          <span className="text-slate-700 text-sm" data-id="element-387" data-mp="11p47tyx655cc">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-388" data-mp="1arn6e6tx8vss">
                  {volume.sequenceIntro && <p className="text-[#520128] font-semibold text-sm mb-2" data-id="element-389" data-mp="1fpexwzqnmfwg">{volume.sequenceIntro}</p>}
                  <p className="text-[#520128] font-bold text-sm bg-[#F1E6D8] border border-[#E6D5BF] rounded-lg px-3 py-2" data-id="element-390" data-mp="3hg078dz0yq28">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-[#F8F3EC] border border-[#E6D5BF] border-l-4 border-l-[#520128] rounded-xl p-4 mt-auto" data-id="element-391" data-mp="3edvou89lwpww">
                <span className="text-[#520128] font-bold block mb-1" data-id="element-392" data-mp="39gdqfbt7tt35">RESULT</span>
                {volume.resultLead && <p className="text-slate-700 text-sm" data-id="element-393" data-mp="3odwcu7if7u7f">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-[#520128]" data-id="element-394" data-mp="3jc708nfjv8h8">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-700 text-sm" data-id="element-395" data-mp="3seg9l9z30vt1">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-[#8E2C5C]" data-id="element-396" data-mp="axydvx3mfdxi">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}